// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"499a65a0","118":"dad03eb3","331":"36bb537f","477":"11cfb149","478":"3438d46c","523":"58befa88","745":"447ab32a","761":"feecd204"}[chunkId] + ".chunk.js";
};